import { formatDateTime } from '../../utils/dateFormat';

// Who did it — the one way a workflow page names an event's actor
// (docs/workflow-ui.md §4.3). Request event feeds carry `actorName`, resolved
// on the server by email (server/repositories/actorNames.js); feeds that do
// not carry it fall back to the email.
export const actorLabel = (ev) => (ev && (ev.actorName || ev.actorEmail)) || 'system';

/**
 * The latest event with one of `actions`, or null. Event feeds come back
 * newest-first, so the first match is the current decision.
 */
export const latestEventOf = (events = [], actions = []) =>
  (events || []).find((ev) => actions.includes(ev.action)) || null;

/** "Approved by Amy Tan (test3) · 15-Sep-2026 13:27" — null when the event is missing. */
export const decisionLine = (verb, ev) =>
  (ev ? `${verb} by ${actorLabel(ev)} · ${formatDateTime(ev.createdAt)}` : null);
